import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 36 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({
    children,
    delay = 0,
    mode = "animate",
    className = "",
}) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const show = mode === "animate" ? true : inView;
    return (
        <span ref={ref} className="block overflow-hidden pb-[0.08em]">
            <motion.span
                className={`block ${className}`}
                initial={{ y: "112%" }}
                animate={show ? { y: 0 } : {}}
                transition={{ duration: 1.05, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
};

export const SectionTag = ({ children, className = "" }) => (
    <FadeUp
        className={`flex items-center gap-3 text-xs font-mono tracking-[0.28em] uppercase text-emerald-400 ${className}`}
    >
        <span className="h-px w-10 bg-emerald-500/60" />
        {children}
    </FadeUp>
);

export const Stars = ({ className = "h-4 w-4" }) => (
    <span className="inline-flex items-center gap-0.5" aria-label="4.4 out of 5 stars">
        {[0, 1, 2, 3].map((i) => (
            <svg key={i} viewBox="0 0 24 24" className={`${className} fill-amber-400`}>
                <path d="M12 2l2.9 6.26 6.6.72-4.9 4.5 1.35 6.52L12 16.77 6.05 20l1.35-6.52-4.9-4.5 6.6-.72L12 2z" />
            </svg>
        ))}
        <span className="relative inline-block">
            <svg viewBox="0 0 24 24" className={`${className} fill-emerald-950 stroke-amber-400/40`} strokeWidth="1">
                <path d="M12 2l2.9 6.26 6.6.72-4.9 4.5 1.35 6.52L12 16.77 6.05 20l1.35-6.52-4.9-4.5 6.6-.72L12 2z" />
            </svg>
            <span className="absolute inset-0 overflow-hidden" style={{ width: "40%" }}>
                <svg viewBox="0 0 24 24" className={`${className} fill-amber-400`}>
                    <path d="M12 2l2.9 6.26 6.6.72-4.9 4.5 1.35 6.52L12 16.77 6.05 20l1.35-6.52-4.9-4.5 6.6-.72L12 2z" />
                </svg>
            </span>
        </span>
    </span>
);
